/* Administración del portal de exámenes de textos de idiomas */

export const es = {
	/* Elementos de menú */
	'menu.serviceagreement': 'Acuerdo de servicio',
	'menu.statusServiceAgreementGreen': 'Estado del acuerdo: al día',
	'menu.statusServiceAgreementRed': 'Estado del acuerdo: caducada',
	'menu.statusServiceAgreementYellow': 'Estado del acuerdo: retrasado',
	'menu.certification': 'Pendiente de Certificación Digital',
	'menu.newReport': 'Nuevo informe manual',
	'menu.discardMaterial': 'Eliminación de materiales',
	'menu.messages': 'Mensajes',
	'menu.start': 'Inicio',
	'menu.retreat': 'Retiro',
	'menu.graphics': 'Gráficos',
	'menu.histology': 'Histología',
	'menu.generalCytology': 'Citología general',
	'menu.immunology': 'Inmunología - Cuchillas',
	'menu.taskControl': 'Control de Tareas',
	'menu.doctorTasks': 'Tareas del medico',
	'menu.materialDisposal': 'Eliminación de materiales',
	'menu.archivingRequisitionMaterials': 'Archivo y Requisición de Materiales',
	'menu.reports': 'Informes',
	'menu.requestsPanel': 'Panel de solicitudes',
	'menu.version': 'Versión',
	'menu.integratesoul': 'Integración del alma',

	/* Enlaces */
	'link.integratesoul.cas': 'Soul',
	'link.integratesoul.insurance': 'Seguro de salud facturación',
	'link.integratesoul.sus': 'SUS facturación',
	'link.integratesoul.pep': 'Pep',
	'link.integratesoul.psdi': 'Psdi',

	/* Protocol */
	'protocol.ventana': 'Integración de Ventana',
	'protocol.date': 'Fecha',
	'protocol.doctor': 'Médico',
	'protocol.case': 'Caso',
	'protocol.protocol': 'Protocolo',
	'protocol.blade': 'Blade',
	'protocol.sent': 'Enviado',
	'protocol.recognized': 'Reconocido',
	'protocol.chanting': 'Sonrojado',
	'protocol.flushed': 'Lavado',
	'protocol.finished': 'Terminado',

	/* Pantalla de ingreso al sistema */

	'general.title': 'Anatomía Patológica',
	'general.title-min': 'Anatomía',
	'general.copyright': 'MV Sistemas © 2024 Todos los derechos reservados',
	'general.user': 'Usuario',
	'general.password': 'Contraseña',
	'general.incorrectPassword': 'Contraseña incorrecta. Inténtalo de nuevo.',
	'general.incorrectUser': 'Usuario incorrecto. Inténtalo de nuevo.',
	'general.accessAccount': 'Utilice su cuenta para acceder a la ',
	'general.logIn': 'Iniciar sesión',
	'general.forgotPassword': 'Olvido la contraseña?',
	'general.version': 'Versión:',
	'general.about': 'Acerca de',
	'general.help': 'Ayuda',
	'general.login.next': 'Siguiente',
	'general.login.back': 'Atrás',
	'general.login.wellcome': 'Bienvenido',
	'general.login.email': 'Correo electrónico',
	'general.login.text': 'Use su cuenta para iniciar sesión',
	'general.login.mail.recovery':
		'Ingrese su correo electrónico y le enviaremos un enlace para cambiar su contraseña',
	'general.login.newaccount': 'Nueva cuenta',
	'general.login.select.company': 'Seleccione una empresa',
	'general.protocol.ventana': 'Integración Ventana',
	'general.login.lowercasePasswordLabel': 'Al menos una letra minúscula',
	'general.login.uppercasePasswordLabel': 'Al menos una letra mayúscula',
	'general.login.numberPasswordLabel': 'Al menos un número',
	'general.login.characterPasswordLabel': 'Al menos un carácter',
	'general.login.lenghtEightPasswordLabel': 'Al menos 8 caracteres',
	'general.login.placeholdPasswordConfirm': 'Confirmar contraseña',
	'general.login.passwordMustBeEqual': 'Las contraseñas deben ser las mismas',

	/* 01. Inicio, Filtros, Búsqueda y Resultado */

	'dashboards.general.pt': 'Portugués (Brasil)',
	'dashboards.general.en': 'Inglés (Internacional)',
	'dashboards.general.es': 'Español',
	'dashboards.general.logout': 'Salir',
	'dashboards.general.settings': 'Ajustes',
	'dashboards.general.patientBusinessName': 'Paciente (Nombre Social)',
	'dashboards.general.medicalRecord': 'Historial médico',
	'dashboards.general.examNumber': 'N° Examen',
	'dashboards.general.attendance': 'Asistencia',
	'dashboards.general.search': 'Búsqueda',
	'dashboards.general.currentFilter': 'Guardar filtro actual',
	'dashboards.general.recordsFound': 'Registros encontrados',
	'dashboards.general.orderBy': 'Ordenar por:',
    'dashboards.general.ascendingOrder': 'Orden Ascendente',
    'dashboards.general.descendingOrder': 'Orden Descendente',
	'dashboards.general.filterBy': 'Filtrar por:',
	'dashboards.general.approvalEnvironment': 'ENTORNO DE APROBACIÓN',
	'dashboards.general.clearFilters': 'Filtros claros',
	'dashboards.general.noFilteredItems': 'Sin elementos filtrados',
	'dashboards.general.knowledgeBase': 'Base de conocimientos',
	'dashboards.general.title': 'Anatomía Patológica',
	'dashboards.general.orderNumber': 'Número de orden',
	'dashboards.general.expectedDeliveryDate': 'Fecha de Entrega Estimada',
	'dashboards.general.expectedDelivery': 'Fecha de Entrega Estimada',
	'dashboards.general.requestDate': 'Fecha de solicitud',
	'dashboards.general.deliveryDate': 'Fecha de entrega',
	'dashboards.general.urgent': 'Urgente',
	'dashboards.general.immunohistochemistryTests':
		'Pruebas de inmunohistoquímica',
	'dashboards.general.socialName': 'Nombre social',

	'dashboards.general.accessionNumber': 'Número de acceso',
	'dashboards.general.attendance': 'Asistencia',
	'dashboards.general.active': 'Activo',
	'dashboards.general.SUSnationalCard': 'Tarjeta nacional SUS',
	'dashboards.general.healthInsurance': 'Seguro de salud',
	'dashboards.general.deliveryDate': 'Fecha de entrega',
	'dashboards.general.releaseDate': 'Fecha de lanzamiento',
	'dashboards.general.datenonCompliance': 'Fecha de incumplimiento',
	'dashboards.general.requestDate': 'Fecha de solicitud',
	'dashboards.general.diagnosis': 'Diagnóstico',
	'dashboards.general.forwarding': 'Reenvío',
	'dashboards.general.exams': 'Examenes',
	'dashboards.general.examGroup': 'Grupo de examen',
	'dashboards.general.report': 'Reporte',
	'dashboards.general.sameEnrollment': 'Registro SAME',
	'dashboards.general.performingPhysician': 'Médico tratante',
	'dashboards.general.medicalReviewer': 'Revisor médico',
	'dashboards.general.requestingDoctor': 'Médico solicitante',
	'dashboards.general.certifyingDoctor': 'Médico Certificador',
	'dashboards.general.nonCompliance': 'Incumplimiento',
	'dashboards.general.externalExamNo': 'Examen externo No.',
	'dashboards.general.examNumber': 'Número de examen',
	'dashboards.general.orderNumber': 'Número de orden',
	'dashboards.general.observationReport': 'Observación del Informe',
	'dashboards.general.pacient': 'Paciente',
	'dashboards.general.procedure': 'Procedimiento',
	'dashboards.general.medicalRecord': 'Historial médico',
	'dashboards.general.nonconformityResolution': 'Resolución de disconformidad',
	'dashboards.general.requestingSector': 'Sector solicitante',
	'dashboards.general.stepStatus': 'Estado del paso',
	'dashboards.general.examType': 'Tipo de examen',
	'dashboards.general.nonconformityType': 'Tipo de no conformidad',
	'dashboards.general.topography': 'Topografía',
	'dashboards.general.serviceUnit': 'Unidad de servicio',
	'dashboards.general.urgent': 'Urgente',
	'dashboards.general.consultationGreater6Months':
		'Periodo de consulta mayor a 6 meses',
	'dashboards.general.consultationGreater1Year':
		'Periodo de consulta mayor a 1 año',
	'dashboards.general.startDateGreaterEndDate.':
		'La fecha de inicio es posterior a la fecha de finalización.',
	'dashboards.general.enterValidEndDate':
		'Por favor, introduzca una fecha de finalización válida.',
	'dashboards.general.sampleReceipt': 'Recibo de muestra',
	'dashboards.general.email': 'Envío de correo electrónico',
	'dashboards.general.certification': 'Certificación digital',
	'dashboards.general.certificationTab': 'Certificación',
	'dashboards.general.personalizedExam':
		'Quiero generar el número de examen personalizado',
	'dashboards.general.initials': 'Iniciales:',
	'dashboards.general.selectInitials': 'Seleccione la posición del acrónimo',
	'dashboards.general.sequence': 'Secuencia:',
	'dashboards.general.selectSequence': 'Seleccione la posición de la secuencia',
	'dashboards.general.currentYear': 'Año corriente:',
	'dashboards.general.selectCurrentYear': 'Seleccione el puesto del año',
	'dashboards.general.separator': 'Separador:',
	'dashboards.general.selectSeparator': 'Seleccione la posición del separador',
	'dashboards.general.exampleNumber': 'El número de examen será el siguiente:',
	'dashboards.general.resultExam':
		'Imprimir protocolo al entregar el resultado del examen',
	'dashboards.general.printStep': 'Imprimir informe agrupado por etapa',
	'dashboards.general.stepNameNotes':
		'Ingrese el nombre que desea para la etapa de Notas',
	'dashboards.general.addendum': 'Adendo',
	'dashboards.general.firstPosition': 'Primera posición',
	'dashboards.general.secondPosition': 'Segunda posición',
	'dashboards.general.thirdPosition': 'Tercera posición',
	'dashboards.general.fourthPosition': 'Cuarta posición',
	'dashboards.general.onCheckList':
		'Habilitar lista de verificación para recepción de material',
	'dashboards.general.printLabel':
		'Imprimir etiqueta después de finalizar el recibo',
	'dashboards.general.pickupScreen':
		'Abra la pantalla de recogida de muestras después de completar la recepción',
	'dashboards.general.standardDoctorBill':
		'Facture siempre con el médico que lo realiza por defecto',
	'dashboards.general.emailSender': 'Remitente (Correo Electrónico):',
	'dashboards.general.password': 'Clave:',
	'dashboards.general.smtp': 'SMTP:',
	'dashboards.general.door': 'Puerta:',
	'dashboards.general.enabledigitalCertification':
		'Habilitar la certificación digital',
	'dashboards.general.HSM': 'Usar HSM',
	'dashboards.general.urldigitalRegistry': 'Url del Registro Digital:',
	'dashboards.general.shippingType': 'Tipo de envío:',
	'dashboards.general.digitalNotaryVersion': 'Versión Notarial Digital:',
	'dashboards.general.addFilters': 'Agregar otros filtros',
	'dashboards.general.noFilter': 'No hay filtros disponibles',
	'dashboards.general.favoriteFilter': 'Filtros favoritos',
	'dashboards.general.noFilterCreated': 'Aún no se han creado favoritos',
	'dashboards.general.savedFilter': 'Guardar el filtro actual como favorito',
	'dashboards.general.filterTitle':
		'Introduzca un título para el filtro favorito',
	'dashboards.general.patternDoctor': 'Médico estándar:',
	'dashboards.general.maximumNumberBlades':
		'Número máximo de diapositivas para lectura:',
	'dashboards.general.enableContinuousGeneration':
		'Habilite la generación continua de numeración de casetes',
	'dashboards.general.resultSearch': 'Resultado de búsqueda',
	'dashboards.general.toView': 'Para ver',
	'dashboards.general.fillField': 'Rellena este campo',
	'dashboards.general.occurrencesReports': 'Informes Ocurrencias:',
	'dashboards.general.today': 'Este Dia',
	'dashboards.general.yesterday': 'Ayer',
	'dashboards.general.beforeYesterday': 'Antes de ayer',
	'dashboards.general.oneWeekAgo': 'Hace 1 semana',
	'dashboards.general.week': 'semana',
	'dashboards.general.month': 'Mes',
	'dashboards.general.fifteenDaysAgo': 'Hace 15 días',
	'dashboards.general.aMonthAgo': 'Hace 1 mes',
	'dashboards.general.twoMonthsAgo': 'Hace 2 meses',
	'dashboards.general.threeMonthsAgo': 'Hace 3 meses',
	'dashboards.general.sixMonthsAgo': 'Hace 6 meses',
	'dashboards.general.aYearAgo': 'Hace 1 año',
	'dashboards.general.other': 'Otro',
	'dashboards.general.selectPeriod': 'Seleccione un período',
	'dashboards.general.informValidStartDate': 'Introduzca una fecha de inicio válida',
	'dashboards.general.informValidEndDate': 'Introduzca una fecha de finalización válida',
	'dashboards.general.CPF': 'DNI',
	'dashboards.general.birthDate': 'Fecha de nacimiento',

	/* 02. Detalles del examen, informe y editor */

	'dashboards.examDetails.linkExams': 'Enlace exámenes:',
	'dashboards.examDetails.socialName': 'Nombre social: ',
	'dashboards.examDetails.exam': 'Examen: ',
	'dashboards.examDetails.numberExam': 'Número de examen: ',
	'dashboards.examDetails.birthDate': 'Fecha de nacimiento: ',
	'dashboards.examDetails.sex': 'Sexo: ',
	'dashboards.examDetails.previousExamNumber': 'Número de examen anterior: ',
	'dashboards.examDetails.completionDate': 'Fecha de Terminación ',
	'dashboards.examDetails.orderDate': 'Fecha de orden: ',
	'dashboards.examDetails.request': 'Solicitud: ',
	'dashboards.examDetails.attendance': 'Asistencia: ',
	'dashboards.examDetails.attendanceType': 'Tipo de atendimento',
	'dashboards.examDetails.attendanceDate': 'Fecha de Asistencia',
	'dashboards.examDetails.healthInsurance': 'Seguro de salud: ',
	'dashboards.examDetails.canceled': 'Cancelado ',
	'dashboards.examDetails.messages': 'Mensajes ',
	'dashboards.examDetails.block': 'Cantidad de bloques: ',
	'dashboards.examDetails.blade': 'Cantidad de hojas: ',
	'dashboards.examDetails.externalExam': 'Núm. de examen externo: ',
	'dashboards.examDetails.urgent': 'Urgente',
	'dashboards.examDetails.criticalReport': 'Informe crítico',
	'dashboards.examDetails.changeOfUrgency':
		'¿Confirmar el cambio en la urgencia de este informe?',
	'dashboards.examDetails.changeInCriticality':
		'¿Confirmar el cambio en la criticidad de este informe?',
	'dashboards.examDetails.justification': 'Justificación:',
	'dashboards.examDetails.cancel': 'Cancelar',
	'dashboards.examDetails.confirm': 'Confirmar',
	'dashboards.examDetails.patientCriticalReport':
		'Paciente con antecedentes de informe crítico',
	'dashboards.examDetails.requestingDoctor': 'Solicitud de médico:',
	'dashboards.examDetails.examRequest': 'Solicitud de examen:',
	'dashboards.examDetails.expectedDeliveryDate': 'Fecha de Entrega Estimada:',
	'dashboards.examDetails.released': 'LIBERADO',
	'dashboards.examDetails.autoText': 'Texto automático',
	'dashboards.examDetails.attachments': 'Archivos adjuntos',
	'dashboards.examDetails.previousReports': 'Informes anteriores',
	'dashboards.examDetails.reportHistory': 'Historial de informes',
	'dashboards.examDetails.bladeList': 'Lista de cuchillas',
	'dashboards.examDetails.status.nonCompliance': 'Incumplimiento',
	'dashboards.examDetails.status.nochecked': 'No realizado',
	'dashboards.examDetails.status.pending': ' Pendiente',
	'dashboards.examDetails.status.checked': ' Realizado',
	'dashboards.examDetails.status.revision': ' Revisión',
	'dashboards.examDetails.status.notApplicable': ' No aplicable',
	'dashboards.examDetails.status.lecturer': 'Conferenciante',
	'dashboards.examDetails.step.material': 'MATERIAL',
	'dashboards.examDetails.step.macro': 'MACRO',
	'dashboards.examDetails.step.micro': 'MICRO',
	'dashboards.examDetails.step.imuno': 'INMUNE',
	'dashboards.examDetails.step.histo': 'HISTO',
	'dashboards.examDetails.step.cish': 'CISH',
	'dashboards.examDetails.step.fish': 'FISH',
	'dashboards.examDetails.step.pcr': 'PCR',
	'dashboards.examDetails.step.congelacao': 'CONGELACIÓN',
	'dashboards.examDetails.step.conclusao': 'CONCLUSIÓN',
	'dashboards.examDetails.step.errata': 'ERRATA/INFORMACIÓN ADICIONAL',
	'dashboards.examDetails.cid': 'CID',
	'dashboards.examDetails.traceability': 'Trazabilidad',
	'dashboards.examDetails.invoicing': 'Facturación',
	'dashboards.examDetails.resultDelivery': 'Entrega de resultados de examen',
	'dashboards.examDetails.printStep': 'Imprimir escenario',
	'dashboards.examDetails.printLabels': 'Imprimir Etiquetas',
	'dashboards.examDetails.includeRemarks': 'Incluir comentarios',
	'dashboards.examDetails.protocolRequirements': 'Requisitos del protocolo',
	'dashboards.examDetails.freezingRequest': 'Solicitud de congelamiento',
	'dashboards.examDetails.releaseReport': 'Informe de lanzamiento',
	'dashboards.examDetails.blockBladeControl': 'Control de bloques y cuchillas',
	'dashboards.examDetails.sendEmail': 'Enviar correo electrónico',
	'dashboards.examDetails.reopenSteps': 'Reabrir pasos',
	'dashboards.examDetails.openExams': 'Exámenes abiertos',
	'dashboards.examDetails.examLinked': 'Examen con informe vinculado',
	'dashboards.examDetails.nextDeliveryDate': 'Próxima fecha de entrega',
	'dashboards.examDetails.criticalReport': 'Informe crítico',
	'dashboards.examDetails.urgentExam': 'Examen urgente',
	'dashboards.examDetails.printedTermofConsent':
		'Término de consentimiento impreso',
	'dashboards.examDetails.examDeliveredIn': 'Examen Entregado en: ',
	'dashboards.examDetails.billExams': 'Facturar examenes',
	'dashboards.examDetails.multipleExams': 'Múltiplos examenes',
	'dashboards.examDetails.quantity': 'La cantidad:',
	'dashboards.examDetails.examStage': 'Etapa do examen:',
	'dashboards.examDetails.invoice': 'Facturar',
	'dashboards.examDetails.manualDisabled': '* Facturación manual deshabilitada',
	'dashboards.examDetails.unbilledItems':
		'Hay artículos no facturados, ¿quieres cerrar de todos modos?',
	'dashboards.examDetails.yes': 'Sí',
	'dashboards.examDetails.no': 'No',
	'dashboards.examDetails.na': 'No aplica',
	'dashboards.examDetails.changeswillbelost':
		'¡Al cerrar se perderán todos los cambios!',
	'dashboards.examDetails.applicablesteps':
		'* No hay pasos de facturación aplicables para este examen',
	'dashboards.examDetails.selectStage': 'Seleccione el paso del examen',
	'dashboards.examDetails.stageDoctor': 'Médico de escena:',
	'dashboards.examDetails.selectDoctorStage':
		'Seleccione el médico para esta etapa',
	'dashboards.examDetails.new': 'Nuevo',
	'dashboards.examDetails.changed': 'Alterado',
	'dashboards.examDetail.doctorUndefined':
		'¡Doctor realizando el paso indefinido!',
	'dashboards.examDetail.billed': 'Facturado',
	'dashboards.examDetail.pendingBilling': 'Facturación pendiente',
	'dashboards.examDetail.thereWasProblem': 'Había un problema',
	'dashboards.examDetail.addExam': 'Añadir nuevo examen',
	'dashboards.examDetail.viewadditionalinfo': 'ver información adicional',
	'dashboards.examDetail.selectExam': 'Seleccionar examen',
	'dashboards.examDetail.exams': 'Exámenes:',
	'dashboards.examDetail.multiploExams': 'Múltiples exámenes:',
	'dashboards.examDetail.performingPhysician': 'Médico ejecutor:',
	'dashboards.examDetail.selectDoctor': 'Seleccionar médico solicitante',
	'dashboards.examDetail.annotationsExam': 'Notas del examen:',
	'dashboards.examDetail.save': 'Grabar',
	'dashboards.examDetail.edit': 'Editar',
	'dashboards.examDetail.delete': 'Borrar',
	'dashboards.examDetail.billExam': 'Examen de factura',
	'dashboards.examDetail.cancelBilling': 'Cancelar facturación',
	'dashboards.examDetail.generate': 'Generar',
	'dashboards.examDetail.generateImpression': 'Generar impresión',
	'dashboards.examDetail.printLabels': 'Imprimir etiquetas:',
	'dashboards.examDetail.selectAll': 'Seleccionar todo',
	'dashboards.examDetail.bottle': 'Botella: ',
	'dashboards.examDetail.controlLabel': 'Etiqueta de control',
	'dashboards.examDetail.label': 'Etiquetas colgantes',
	'dashboards.examDetail.comments': 'Comentarios',
	'dashboards.examDetail.reportObservation': 'Reporte su observación aquí',
	'dashboards.examDetail.patient': 'Paciente:',
	'dashboards.examDetail.date': 'Fecha:',
	'dashboards.examDetail.numberOfExam': 'Número de examen:',
	'dashboards.examDetail.topography': 'Topografía:',
	'dashboards.examDetail.selectTopography': 'Seleccionar topografía',
	'dashboards.examDetail.CID': 'CID:',
	'dashboards.examDetail.enter': 'Entrar al menos',
	'dashboards.examDetail.searchCharacters': 'caracteres de búsqueda',
	'dashboards.examDetail.selectCID': 'Seleccione el CID',
	'dashboards.examDetail.mainDiagnosis': 'Diagnóstico Principal (CID-O)',
	'dashboards.examDetail.annotations': 'Anotaciones',
	'dashboards.examDetail.generalObservations': 'Observaciones generales',
	'dashboards.examDetail.adding': 'Agregar',
	'dashboards.examDetail.close': 'Cerrar',
	'dashboards.examDetail.cidTopography': 'CID/Topografías',
	'dashboards.examDetail.annotation': 'Anotación:',
	'dashboards.examDetail.toSave': 'Guardar',
	'dashboards.examDetail.mandatoryCID':
		'Obligatorio registrar CID para el informe',
	'dashboards.examDetail.operation': 'Operación:',
	'dashboards.examDetail.sectorChange': 'Cambio de sector',
	'dashboards.examDetail.user': 'Usuario:',
	'dashboards.examDetail.action': 'Acción:',
	'dashboards.examDetail.userJustification': 'Justificación del usuario:',
	'dashboards.examDetail.requisitionFreezingReport':
		'Solicitud de informe de congelamiento',
	'dashboards.examDetail.freezingBlock': 'Bloque de congelación:',
	'dashboards.examDetail.selectFreezingBlock':
		'Seleccione un bloque de congelación (opcional)',
	'dashboards.examDetail.noFreezeBlock':
		'No hay bloques de congelación para este examen',
	'dashboards.examDetail.addBlock': '+ Bloque',
	'dashboards.examDetail.bladeAddOn': 'complemento de la cuchilla',
	'dashboards.examDetail.selectBladeAddOn':
		'Seleccione complemento de cuchilla',
	'dashboards.examDetail.registerNewAddOn': 'Registrar nuevo complemento',
	'dashboards.examDetail.unconformities': 'No conformidades:',
	'dashboards.examDetail.selectUnconformities': 'Seleccione la no conformidad',
	'dashboards.examDetail.freezingTechnician': 'Técnico de Congelación:',
	'dashboards.examDetail.selectTechnician': 'Seleccionar técnico',
	'dashboards.examDetail.freezingPathologist': 'Patólogo de congelación:',
	'dashboards.examDetail.selectPathologist': 'Seleccionar patólogo',
	'dashboards.examDetail.clearFields': 'Borrar campos',
	'dashboards.examDetail.listBlades': 'Lista de cuchillas',
	'dashboards.examDetail.requester': 'Solicitante',
	'dashboards.examDetail.block': 'Bloque',
	'dashboards.examDetail.blade': 'Cuchilla',
	'dashboards.examDetail.performSearch': 'Escriba algo para la búsqueda',
	'dashboards.examDetail.noRecordFound': 'No se encontraron registros',
	'dashboards.examDetail.qtyBlades': 'Cantidad cuchillas',
	'dashboards.examDetail.addBlade': 'Agregar cuchilla',
	'dashboards.examDetail.macroscopicMap': 'Mapa macroscópico',
	'dashboards.examDetail.technicalArea': 'Área técnica',
	'dashboards.examDetail.generalCytology': 'Citología general',
	'dashboards.examDetail.freezing': 'Congelación',
	'dashboards.examDetail.blockandBladeControl':
		'Control de bloques y cuchillas',
	'dashboards.examDetail.table.blade': 'Cuchilla',
	'dashboards.examDetail.table.delegateTechnician': 'Técnico delegado',
	'dashboards.examDetail.table.exam': 'Examen',
	'dashboards.examDetail.table.status': 'Status',
	'dashboards.examDetail.table.registrationDate': 'Fecha de Registro',
	'dashboards.examDetail.table.noResultsFound': 'Ningún resultado encontrado',
	'dashboards.examDetail.table.coloring': 'Colorido',
	'dashboards.examDetail.table.technician': 'Técnico',
	'dashboards.examDetail.table.pathologist': 'Patólogo',
	'dashboards.examDetail.table.complement': 'Complementar',
	'dashboards.examDetail.table.editComplement': 'Editar adiciones',
	'dashboards.examDetail.cancelStep.confirm': 'Confirmar la reapertura de pasos',
	'dashboards.examDetail.cancelStep.confirmCancel':'Tras la confirmación, se volverán a abrir los pasos siguientes',
	'dashboards.examDetail.cancelStep.select': 'Seleccione el paso',
	'dashboards.examDetail.cancelStep.selectStep': '- Seleccione un paso',
	'dashboards.examDetail.cancelStep.legends': 'Subtítulos:',
	'dashboards.examDetail.cancelStep.stepsCompleted':
		'Pasos que quedarán completados',
	'dashboards.examDetail.cancelStep.stepsCanceled': 'Pasos que serán reabiertos',
	'dashboards.examDetail.cancelStep.stepsNotAllowed': 'Pasos no permitidos reabrir la ejecución por parte del usuario',
	'dashboards.examDetail.cancelStep.stepCancel': 'Reabrir paso(s)',
	'dashboards.examDetail.sendReportEmail':
		'Enviar informe por correo electrónico -',
	'dashboards.examDetail.recipient': 'Recipiente',
	'dashboards.examDetail.recipientEmail':
		'Ingrese el correo electrónico del destinatario',
	'dashboards.examDetail.subject': 'Tema',
	'dashboards.examDetail.subjectEmail':
		'Ingrese el asunto del correo electrónico',
	'dashboards.examDetail.enterText': 'Introduce un texto...',
	'dashboards.examDetail.protocolRequestAvailable':
		'Solicitud de protocolo disponible',
	'dashboards.examDetail.protocolRequirements':
		'Requisitos del protocolo de informes',
	'dashboards.examDetail.antibodyInformed':
		'Anticuerpo ya informado. ¿Quieres lanzar de nuevo?',
	'dashboards.examDetail.errataInformed':
		'¿Desea iniciar la Errata para el informe ya completado y/o publicado?',
	'dashboards.examDetail.blocky': 'Bloque:',
	'dashboards.examDetail.numberOfExame': 'Número de examen:',
	'dashboards.examDetail.Material': 'Material',
	'dashboards.examDetail.doctorRequesting': 'Médico solicitante:',
	'dashboards.examDetail.typeAntibody': 'Tipo de anticuerpo:',
	'dashboards.examDetail.typeSelect': 'Seleccione tipo',
	'dashboards.examDetail.destiny': 'Destino:',
	'dashboards.examDetail.antibodies': 'Anticuerpos:',
	'dashboards.examDetail.selectReagent': 'seleccionar reactivo',
	'dashboards.examDetail.addAntibodies': 'Añadir anticuerpos',
	'dashboards.examDetail.antigen': 'Antígeno',
	'dashboards.examDetail.delete': 'Borrar',
	'dashboards.examDetail.selectCase': 'Seleccionar caso (bloque)',
	'dashboards.examDetail.favorites': 'Favoritos',
	'dashboards.examDetail.saveFavorite': 'Guardar favorito',
	'dashboards.examDetail.saveFilter': ' Guardar filtro',
	'dashboards.examDetail.favoriteName': 'Nombre favorito:',
	'dashboards.examDetail.stepCancellation': 'Reapertura de paso',
	'dashboards.examDetail.justificationCancellation': 'Justificación de la reapertura',
	'dashboards.examDetail.justificationForCancellation': 'Justificación para la cancelación',
	'dashboards.examDetail.justificationForReopening': 'Justificación de la reapertura',
	'dashboards.examDetail.comeBack': 'Regresar',
	'dashboards.examDetail.cancelStep': 'Reabrir paso',
	'dashboards.examDetail.cancellation': 'Cancelación:',
	'dashboards.examDetail.cancelingAllowed':
		'No se permite cancelar la recepción de material de informes con gestiones realizadas',
	'dashboards.examDetail.confirmCancellation': 'Confirmar cancelación',
	'dashboards.examDetail.deliveryCancellation': 'Cancelación de entrega',
	'dashboards.examDetail.message.user': 'Mensajes - Usuario',
	'dashboards.examDetail.message.report': 'Mensajes - Informe',
	'dashboards.examDetail.message.conversations': 'Conversaciones',
	'dashboards.examDetail.message.subject': 'Tema:',
	'dashboards.examDetail.message.messageRecipient': 'Destinatario del mensaje',
	'dashboards.examDetail.message.submit': 'Enviar',
	'dashboards.examDetail.message.noConversationFound':
		'No se encontró ninguna conversación',
	'dashboards.examDetail.message.conversationTopic':
		'Asunto de la conversación:',
	'dashboards.examDetail.message.firstMessage': 'Primer mensaje:',
	'dashboards.examDetail.message.blockedMessages':
		'¡El envío de mensajes está bloqueado porque este informe ya se entregó!',
	'dashboards.examDetail.certificate': 'Certificado',
	'dashboards.examDetail.noCertificate': 'No certificado',
	'dashboards.examDetail.linkPastExams':
		'Vincular exámenes anteriores al informe',
	'dashboards.examDetail.CIDReport': 'CID del informe',
	'dashboards.examDetail.wasNotTyped':
		'El informe para el examen no fue mecanografiado. Introduzca texto en el informe para incluir el CID',
	'dashboards.examDetail.wasNotTypedMorphology':
		'Não foi digitado o laudo para o exame. Insira um texto no laudo para realizar a MorfologEl informe para el examen no fue mecanografiado. Insertar un texto en el informe para realizar la Morfología',
	'dashboards.examDetail.notTyped':
		'El informe para el examen no fue mecanografiado. Este informe solo se puede registrar como pendiente. Controlar!',
	'dashboards.examDetail.newExam':
		'El nuevo examen utilizará el mismo material que el examen vinculado',
	'dashboards.examDetail.link': 'Enlace',
	'dashboards.examDetail.noLink': 'Desconectar',
	'dashboards.examDetail.linkReport': 'Enlace al informe',
	'dashboards.examDetail.noLinkReport': 'Desvincular del informe',
	'dashboards.examDetail.justification': 'Justificación',
	'dashboards.examDetail.informCID': 'Es necesario informar al CID',
	'dashboards.examDetail.setCID': 'Defina un CID principal',
	'dashboards.examDetail.reportConclusionExam':
		'Informe de finalización del examen',
	'dashboards.examDetail.reportAndConclusion': 'Alabar y terminar',
	'dashboards.examDetail.requisitionReportProtocols':
		'Requisición de protocolos de reporte',
	'dashboards.examDetail.sampleCollection': 'Coleccion de muestra',
	'dashboards.examDetail.finalizeMaterialReceipt':
		'Finalizar recepción de material',
	'dashboards.examDetail.toReceive': 'Para recibir',
	'dashboards.examDetail.externalExam': 'Examen externo',
	'dashboards.examDetail.Unconformities': 'No conformidades',
	'dashboards.examDetail.attachment': 'Archivo adjunto',
	'dashboards.examDetail.docExternal': 'Doc. externo',
	'dashboards.examDetail.Cancellation': 'Cancelación',
	'dashboards.examDetail.checklist': 'Lista de verificación',
	'dashboards.examDetail.savePending': 'Guardar como pendiente',
	'dashboards.examDetail.finalize': 'Finalizar',
	'dashboards.examDetail.nextStep': 'Próximo paso',
	'dashboards.examDetail.reopenStep': 'Reabrir paso',
	'dashboards.examDetail.reopenStepQuestion': '¿Quieres reabrir el paso?',
	'dashboards.examDetail.changeTopography': 'Cambiar topografía',
	'dashboards.examDetail.bottleCancellation': 'Cancelación de botella',
	'dashboards.examDetail.lastBottle':
		'Esta es la última botella. Si se cancela, el recibo también se cancelará y se perderá el número de examen.',
	'dashboards.examDetail.reportTopography': 'Reportar topografía',
	'dashboards.examDetail.registerNewTopography': 'Registrar nueva topografía',
	'dashboards.examDetail.removedBottle': 'Botella removida',
	'dashboards.examDetail.addBottles': 'Botella(s) añadidas',
	'dashboards.examDetail.materialReceipt': 'Recepción de material realizada',
	'dashboards.examDetail.deleteExternalDocument': 'Eliminar documento externo',
	'dashboards.examDetail.receiptUsingExternalExam':
		'Recibo mediante examen externo',
	'dashboards.examDetail.externalExamNumber': 'Número de examen externo',
	'dashboards.examDetail.update': 'Actualizar',
	'dashboards.examDetail.deleteExternalExam': 'Eliminar examen externo',
	'dashboards.examDetail.printIndividualTerm': 'Imprimir término individual',
	'dashboards.examDetail.printer': 'Impresora',
	'dashboards.examDetail.selectPrinter':
		'Seleccione una impresora para emitir el término',
	'dashboards.examDetail.printConsolidatedTerm': 'Imprimir término consolidado',
	'dashboards.examDetail.addNonconformity': 'Añadir No Conformidad',
	'dashboards.examDetail.displayNoncompliance':
		'Mostrar incumplimientos en el texto final del informe',
	'dashboards.examDetail.confirmPrintConsolidated':
		'Confirmar e imprimir consolidado',
	'dashboards.examDetail.confirmClose': 'Confirmar y cerrar',
	'dashboards.examDetail.printTerm': 'Término de impresión',
	'dashboards.examDetail.noItems':
		'No hay elementos registrados para la lista de verificación de verificación',
	'dashboards.examDetail.receiptMaterialBlocked':
		'La recepción de material ha sido bloqueada',
	'dashboards.examDetail.questionnaireSuccessfully':
		'Cuestionario respondido con éxito',
	'dashboards.examDetail.openExam': 'Exámenes abiertos:',
	'dashboards.examDetail.solicted': 'Preguntado por ',
	'dashboards.examDetail.performedBy': ' Ejecutar por',
	'dashboards.examDetail.executed': ' Ejecutado',
	'dashboards.examDetail.step': ' Escenario',
	'dashboards.examDetail.pendingMacro': 'Macro pendiente',
	'dashboards.examDetail.Attachment': 'Archivo adjunto:',
	'dashboards.examDetail.fileAttachment': 'Archivo adjunto',
	'dashboards.examDetail.deletearchive': '¿Quieres eliminar el archivo?',
	'dashboards.examDetail.selectarchive': 'Seleccione el archivo',
	'dashboards.examDetail.download': 'Download',
	'dashboards.examDetail.successAttached': '¡Archivo adjunto con éxito!',
	'dashboards.examDetail.attachmentFailure': '¡No se pudo adjuntar el archivo!',
	'dashboards.examDetail.attachmentError':
		'¡Este archivo ya está adjunto al examen!',
	'dashboards.examDetail.fileRemoved': 'Archivo eliminado con éxito',
	'dashboards.examDetail.documentDescription': 'Descripción del documento:',
	'dashboards.examDetail.receiveDocument': 'Recibir documento',
	'dashboards.examDetail.deliveredIn': ' Entregado en',
	'dashboards.examDetail.receivedIn': 'Documento recibido en',
	'dashboards.examDetail.documentRegistered': 'Documento registrado!',
	'dashboards.examDetail.complementaryExamRemoved':
		'¡Examen complementario eliminado!',
	'dashboards.examDetail.additionalExamAdded': '¡Examen adicional agregado!',
	'dashboards.examDetail.updatedSupplementaryExam':
		'¡Examen complementario actualizado!',
	'dashboards.examDetail.failedEditExam': 'No se pudo editar el examen',
	'dashboards.examDetail.questionnaireHistory': 'Historial del cuestionario:',
	'dashboards.examDetail.replyAgain': 'Responder de nuevo',
	'dashboards.examDetail.impeditive': 'Impeditivo',
	'dashboards.examDetail.quiz': 'Prueba:',
	'dashboards.examDetail.finishReceivingMaterial':
		'¿Quieres terminar de recibir material sin informar nuevas botellas?',
	'dashboards.examDetail.sampleOrigin': 'Ubicación de origen de la muestra',
	'dashboards.examDetail.receivedBy': 'Recebido por',
	'dashboards.examDetail.processFor': 'Proceso para',
	'dashboards.examDetail.delegationTo': 'Delegación a',
	'dashboards.examDetail.receiptCompletedMaterial':
		'Recepción de material terminado',
	'dashboards.examDetail.materialSavedPending':
		'Material guardado como pendiente',
	'dashboards.examDetail.errorExamExternal':
		'Hubo un error al recibir el examen externo',
	'dashboards.examDetail.bottleCanceled':
		'Botella cancelada por eliminación de examen externo asociado',
	'dashboards.examDetail.receiptMaterialCanceled':
		'Recepción de material cancelada con éxito',
	'dashboards.examDetail.externalExamDeleted':
		'Número de examen externo eliminado con éxito',
	'dashboards.examDetail.errorUpdateInformation':
		'Ocurrió un error al intentar actualizar la información',
	'dashboards.examDetail.unableCancelSteps': 'No se pueden cancelar los pasos',
	'dashboards.examDetail.grouped': 'Agrupados',
	'dashboards.examDetail.general': 'General',
	'dashboards.examDetail.noAutoTextRegistered':
		'No hay texto automático registrado',
	'dashboards.examDetail.shortcut': 'Atajo',
	'dashboards.examDetail.defaultText': 'texto predeterminado',
	'dashboards.examDetail.noAttachmentsRegistered':
		'No hay archivos adjuntos registrados',
	'dashboards.examDetail.noClinicalReportExam':
		'No hay informe clínico para este examen',
	'dashboards.examDetail.reportAddedReport':
		'Informe clínico añadido al informe',
	'dashboards.examDetail.insertMapReport':
		'Insertar mapa macroscópico en el informe',
	'dashboards.examDetail.listBlocks': 'Lista de bloqueos',
	'dashboards.examDetail.noPreviousReportRegistered':
		'No se registró informe previo',
	'dashboards.examDetail.previousReport':
		'Informe previo',
	'dashboards.examDetail.noHistoryRecorded': 'Sin historial registrado',
	'dashboards.examDetail.dateChange': 'Fecha de modificación:',
	'dashboards.examDetail.insertReport': 'Insertar en el informe',
	'dashboards.examDetail.noBlades':
		'¡No hay cuchillas en la lista para este paso!',
	'dashboards.examDetail.multipleExams': 'Múltiples Exámenes',
	'dashboards.examDetail.includeClinicalReports': 'Incluir informes clínicos',
	'dashboards.examDetail.crm': 'CRM',
	'dashboards.examDetail.reviewer': 'Reseñante',
	'dashboards.examDetail.notesSelectText': 'NOTAS - Seleccionar texto',
	'dashboards.examDetail.completeTheExam':
		'El examen debe completarse para acceder a este paso',
	'dashboards.examDetail.impedingNonCompliance':
		'Hay un impedimento de incumplimiento en el área técnica.',
	'dashboards.examDetail.fullyReleaseReport':
		'¿Quieres publicar el informe completo?',
	'dashboards.examDetail.fullRelease': 'Publicación completa del Informe',
	'dashboards.examDetail.headsUp': '¡Aviso!',
	'dashboards.examDetail.reportSave': 'Informe guardado correctamente',
	'dashboards.examDetail.notAllowed': 'Autorización no permitida',
	'dashboards.examDetail.onlyDoctors': '¡Solo los médicos pueden alabar!',
	'dashboards.examDetail.reportNonCompliance':
		'Este informe tiene una o más no conformidades',
	'dashboards.examDetail.previousExams':
		'Número de examen(es) crítico(s) anterior(es)',
	'dashboards.examDetail.laud': 'Alabar',
	'dashboards.examDetail.laudPendent': 'Alabar pendiente',
	'dashboards.examDetail.laudAndConclusion': 'Alabar y completar el examen',
	'dashboards.examDetail.laudLecturer': 'Alabar conferenciante',
	'dashboards.examDetail.cassettes': 'Casetes',
	'dashboards.examDetails.errata': 'ERRATA/INFORMACIÓN ADICIONAL',
	'dashboards.examDetails.years': 'años',
	'dashboards.examDetails.months': 'meses',
	'dashboards.examDetails.masculine': 'Masculino',
	'dashboards.examDetails.feminine': 'Femenino',
	'dashboards.examDetails.undefined': 'Indefinido',
	'dashboards.examDetails.examCassetteGeneration':
		'Generación de casetes de examen',
	'dashboards.examDetails.fullySubmittedExam':
		'Material totalmente presentado al examen.',
	'dashboards.examDetails.selectBottle': 'Seleccione la botella',
	'dashboards.examDetails.antigens': 'Antígenos:',
	'dashboards.examDetails.selectMaterial': 'Seleccionar material',
	'dashboards.examDetails.registerNewMaterial': 'Registrar material nuevo',
	'dashboards.examDetails.selectTechnician': 'Seleccione el técnico',
	'dashboards.examDetails.selectDoctor': 'Seleccione el medico',
	'dashboards.examDetails.typeDiscard': 'Tipo de descarte:',
	'dashboards.examDetails.selectTypeDisposal':
		'Seleccione el tipo de disposición',
	'dashboards.examDetails.doctorRequestingDisposal':
		'Médico que solicita la disposición:',
	'dashboards.examDetails.groupSelectedCassettes':
		'Cassettes seleccionados del grupo',
	'dashboards.examDetails.canceled': 'Cancelado',
	'dashboards.examDetails.canceledCassettes': 'Casetes cancelados',
	'dashboards.examDetails.laud': 'Reporte:',
	'dashboards.examDetails.medicalRecord': 'Historial médico:',
	'dashboards.examDetails.datePerformed': 'Volver a la lista',
	'dashboards.examDetails.backToList': 'Voltar para lista',
	'dashboards.examDetails.enableEditing': 'Guardar cambios',
	'dashboards.examDetails.saveChange': 'Salvar alteração',
	'dashboards.examDetails.addCassete': 'Agregar casete',
	'dashboards.examDetails.urgentUserExam':
		'Examen marcado como urgente en el mapa macroscópico por el usuario',
	'dashboards.examDetails.printReceptacleControl':
		'Control del receptáculo de impresión',
	'dashboards.examDetails.finishMacroscopicMap': 'Terminar mapa macroscópico',
	'dashboards.examDetails.reopenMacroscopicMap': 'Reabrir mapa macroscópico',
	'dashboards.examDetails.recorded': 'GRABADO',
	'dashboards.examDetails.canceledBlock': 'Cancelar bloque',
	'dashboards.examDetails.shippingDate': 'Fecha de envío:',
	'dashboards.examDetails.certifySelection': 'Certificar Selección',
	'dashboards.examDetails.certifyAll': 'Certificar Todo',
	'dashboards.examDetails.invalidCPF': 'DNI no válido',
	'dashboards.examDetails.submitCertification': 'Enviar para la certificación',
	'dashboards.examDetails.cpf': 'DNI:',
	'dashboards.examDetails.pin': 'PIN:',
	'dashboards.examDetails.certify': 'Certificar',
	'dashboards.examDetails.reports': 'Informes:',
	'dashboards.examDetails.noncomplianceReport': 'Incumplimiento del informe',
	'dashboards.examDetails.reportLabels': 'Etiquetas de informe',
	'dashboards.examDetails.openExamReport': 'Exámenes abiertos del informe',
	'dashboards.examDetails.reportBaskets': 'Reportar cestas',
	'dashboards.examDetails.reportProtocol': 'Protocolo de informe',
	'dashboards.examDetails.saved':
		'¿Guardar los cambios en el texto del informe antes de salir?',
	'dashboards.examDetails.saveEditions': 'Guardar ediciones',
	'dashboards.examDetails.launchAddendumReport':
		'Quiere lanzar la adenda para el informe ya realizado y/o publicado',
	'dashboards.examDetails.doctorPerformingReport':
		'Informar al médico tratante del informe',
	'dashboards.examDetails.medicalReportReviewer':
		'Informar al médico revisor del informe.',
	'dashboards.examDetails.filterName': 'Nombre del filtro:',
	'dashboards.examDetails.visibleGroupUsers':
		'Visible para los usuarios del grupo:',
	'dashboards.examDetails.startupFilter': 'Establecer como filtro de inicio',
	'dashboards.examDetails.materialReceipt': 'Recepción de materiales',
	'dashboards.examDetails.macro': 'Macroscopia',
	'dashboards.examDetails.micro': 'Microscopía',
	'dashboards.examDetails.fish': 'Fish',
	'dashboards.examDetails.cish': 'Cish',
	'dashboards.examDetails.histo': 'Histo',
	'dashboards.examDetails.notes': 'Los grados',
	'dashboards.examDetails.conclusion': 'Conclusión',
	'dashboards.examDetails.printed': 'Impreso',
	'dashboards.examDetails.term': 'Término:',
	'dashboards.examDetails.unitys': 'Unidades:',
	'dashboards.examDetails.periods': 'Periodos:',
	'dashboards.examDetails.yearsOld': 'Años:',
	'dashboards.examDetails.reset': 'Reiniciar',
	'dashboards.examDetails.noPendingCertificates': 'Sin certificados pendientes',
	'dashboards.examDetails.billingStatus': 'Estado de facturación',
	'dashboards.examDetails.examStatus': 'Estado del examen',
	'dashboards.examDetails.PatientSSN': 'DNI del paciente',
	'dashboards.examDetails.reportDeliveredPortal': 'Informe entregado: Portal de exámenes',
	'dashboards.examDetails.imagesVivaceConnect': 'Imágenes asociadas con el examen disponibles para ver en Vivace Connect',
	'dashboards.examDetails.microscopist': 'Microscopista',
	'dashboards.examDetails.tagNew': '(NUEVO)',
	'dashboards.examDetails.tagSaved': '(SALVADO)',
	'dashboards.examDetails.tagCancelled': '(CANCELADO)',
	'dashboards.examDetails.externalExamFlask': 'Vial derivado de examen externo',
	'dashboards.examDetails.errorDate': 'Fecha invalida',

	/* 03.Colección de muestras */

	/* 04.Gráficos */

	'dashboards.graphics.graphics': 'Gráficos',
	'dashboards.graphics.reportsDelivered': 'INFORMES ENTREGADOS POR PERÍODO',
	'dashboards.graphics.historyNonCompliance':
		'HISTORIAL DE INCUMPLIMIENTO POR PERÍODO',
	'dashboards.graphics.averageTime': 'TIEMPO MEDIO DE PASOS',
	'dashboards.graphics.materialProductivity': 'PRODUCTIVIDAD MATERIAL',
	'dashboards.graphics.macroscopicMap': 'MAPA MACROSCÓPICO DE PRODUCTIVIDAD',
	'dashboards.graphics.selectScenery': 'Seleccione un escenario',
	'dashboards.graphics.initial': 'Inicial',
	'dashboards.graphics.last': 'Final',
	'dashboards.graphics.generate': 'Generar',
	'dashboards.graphics.reportsDeliveredMonth':
		'Informes totales entregados por mes',
	'dashboards.graphics.noDataPeriod': 'Sin datos en el periodo reportado',
	'dashboards.graphics.totalOfBottles':
		'Total Botellas generadas en el periodo',
	'dashboards.graphics.totalOfCassetes':
		'Total de Cassettes generados en el periodo',
	'dashboards.graphics.freezingBlade': 'LAMINA_CONGELACION',

	/* 05.Histología */

	'dashboards.histology.histologyInclusion': 'Inclusión de Histología',
	'dashboards.histology.histologyBlades': 'Cuchillas de Histología',
	'dashboards.histology.delegation': 'Delegación',
	'dashboards.histology.editBlock': 'Editar bloque',
	'dashboards.histology.consultCytotechnicians': 'Consultar Citotécnicos',
	'dashboards.histology.responsibleCytotechnician': 'Citotécnico Responsable',
	'dashboards.histology.detailsCytotechnicianDelegation':
		'Detalles de la delegación de Citotécnicos',
	'dashboards.histology.exam': 'Examen: ',
	'dashboards.histology.noBladeFound': 'No se encontró ninguna cuchilla',
	'dashboards.histology.errorWritingBlades': 'Error al escribir cuchillas',
	'dashboards.histology.successfullyDelegatedBlade':
		'Cuchilla delegada con éxito',
	'dashboards.histology.bladeSuccessfullyRequested':
		'Cuchilla solicitada con éxito',
	'dashboards.histology.successfullyCanceledDelegations':
		'Delegaciones canceladas con éxito',
	'dashboards.histology.cutout': 'Recorte',
	'dashboards.histology.biopsy': 'Biopsia',
	'dashboards.histology.autopsy': 'Autopsia',
	'dashboards.histology.piece': 'Pieza',
	'dashboards.histology.withAntibodies': 'Con anticuerpos',
	'dashboards.histology.sentries': 'Centinelas',
	'dashboards.histology.selectBlocks': 'Seleccionar bloques',
	'dashboards.histology.clean': 'Limpio',
	'dashboards.histology.cancelBlock': 'Cancelar bloque',
	'dashboards.histology.cancelBlade': 'Cancelar cuchilla',
	'dashboards.histology.cancelThisBlock':
		'¿Está seguro de que desea cancelar este bloque?',
	'dashboards.histology.cancelThisBlade':
		'¿Está seguro de que desea cancelar esta cuchilla?',
	'dashboards.histology.nonconformitySuccessfullyAdded':
		'No conformidad añadida con éxito',
	'dashboards.histology.displayUpdatedSuccessfully':
		'Pantalla actualizada con éxito',
	'dashboards.histology.resolutionSavedSuccessfully':
		'Resolución guardada con éxito',
	'dashboards.histology.resolveIn': 'Resuelto en',
	'dashboards.histology.includedIn': 'Incluido en',
	'dashboards.histology.inStep': 'al paso',
	'dashboards.histology.blockedNonconformity':
		'¡Bloqueado por impedir la no conformidad!',
	'dashboards.histology.successfullyMoved': 'Movido con éxito',
	'dashboards.histology.puncture': 'Punción',
	'dashboards.histology.autoInput': 'Entrada automática',
	'dashboards.histology.createBlades': 'Crear cuchillas',
	'dashboards.histology.unableMoveSelectedMaterials':
		'No se pueden mover los materiales seleccionados',

	/* 06.Citología */

	'dashboards.cytology.geral': 'Citología general',
	'dashboards.cytology.technical': 'Todos los Técnicos',
	'dashboards.cytology.danglingBlades': 'Cuchillas colgantes',
	'dashboards.cytology.bladesInProgress': 'Cuchillas en progreso',
	'dashboards.cytology.bladesReady': 'Cuchillas preparadas',
	'dashboards.cytology.addBlades': 'Agregando cuchillas',
	'dashboards.cytology.editBlades': 'Editar cuchillas',
	'dashboards.cytology.numberExam': 'Examen no.',
	'dashboards.cytology.blockCytology': 'Bloque de citología:',
	'dashboards.cytology.selectBlock':
		'Seleccione un bloque de citología (opcional)',
	'dashboards.cytology.noBlock': 'No hay bloques de citología para este examen',
	'dashboards.cytology.technician': 'Técnico:',
	'dashboards.cytology.pathologist': 'Patólogo:',
	'dashboards.cytology.cytology': 'Citología',
	'dashboards.cytology.addCassetes': 'Adición de casetes de citología',
	'dashboards.cytology.bottles': 'Botellas:',
	'dashboards.cytology.selectBottle': 'Seleccionar botella',
	'dashboards.cytology.numberOfCassetes': 'Número de casetes:',
	'dashboards.cytology.fragmentsCassette': 'Fragmentos por casetes:',
	'dashboards.cytology.multipleFragments': '¿Múltiples fragmentos?',
	'dashboards.cytology.newCuts': 'Nuevos cortes',
	'dashboards.cytology.colors': 'Coloraciones:',
	'dashboards.cytology.selectAntigens': 'Seleccione los antígenos',
	'dashboards.cytology.selectMaterial': 'Seleccionar material',
	'dashboards.cytology.type': 'Tipo:',
	'dashboards.cytology.melanomaSentinel': 'Centinela del melanoma',
	'dashboards.cytology.mamaSentry': 'Mama Centinela',
	'dashboards.cytology.macroscopyTechnician': 'Técnico macroscópico:',
	'dashboards.cytology.doctorMacroscopy': 'Medico macroscopia:',
	'dashboards.cytology.selectDoctor': 'Seleccione médico',
	'dashboards.cytology.addCassete': 'Añadir casete',
	'dashboards.cytology.cancel': 'CANCELADO',
	'dashboards.cytology.allFields': 'Rellene todos los campos',
	'dashboards.cytology.successBlock':
		'Bloque creado con éxito. Se ha generado una hoja para este bloque.',
	'dashboards.cytology.selectTechnician': 'Seleccionar técnico responsable',
	'dashboards.cytology.organizeLots': 'Organizar Lotes',
	'dashboards.cytology.organizeLot': 'Organizar Lote',
	'dashboards.cytology.identificationNumber': 'Número de identificación',
	'dashboards.cytology.selectDestiny': 'Seleccionar destino',
	'dashboards.cytology.nameOfExam': 'Nombre del examen',
	'dashboards.cytology.nameOfPatient': 'Nombre del paciente',
	'dashboards.cytology.toAddBlades': 'Añadir cuchillas',
	'dashboards.cytology.batchLabels': 'Etiquetas de lote',
	'dashboards.cytology.sendBatch': 'Enviar en lote',
	'dashboards.cytology.noItemsSend': 'No hay artículos para enviar',
	'dashboards.cytology.printLabelsBatch': 'Imprimir etiquetas en lote',
	'dashboards.cytology.delegationBlades': 'Delegación de palas',
	'dashboards.cytology.consultCytotechnicians': 'Consultar Citotécnicos',
	'dashboards.cytology.statusDelegation':
		'Estado de la delegación de Citotécnicos',
	'dashboards.cytology.delegationDate': 'Fecha de delegación',
	'dashboards.cytology.delegationCytotechnician':
		'Delegación para Citotécnico:',
	'dashboards.cytology.selectCytotechnician': 'Seleccione Citotécnico',
	'dashboards.cytology.search': 'Búsqueda',
	'dashboards.cytology.delegateBlades': 'Cuchillas para delegados',
	'dashboards.cytology.removeDelegation': 'Quitar delegación',
	'dashboards.cytology.cytotechnician': 'Citotécnico',
	'dashboards.cytology.delegatedBlades': 'Cuchillas delegadas',
	'dashboards.cytology.remainingBlades': 'Cuchillas restantes',
	'dashboards.cytology.code': 'Código',
	'dashboards.cytology.poweredBlades': 'Hoja movida con éxito',
	'dashboards.cytology.bladesNotMoved': 'No se pudo actualizar la hoja',
	'dashboards.cytology.updateDate': 'Fecha de actualización',
	'dashboards.cytology.deleteBlade': 'Borrar la hoja ',
	'dashboards.cytology.certaintyDelete':
		'¿Seguro que quieres borrar esta hoja?',
	'dashboards.cytology.nonconformityToBlock':
		'Insertar no conformidad para bloque ',
	'dashboards.cytology.nonconformityToBlade':
		'Insertar disconformidad en la hoja ',
	'dashboards.cytology.nonconformityToReport':
		'Mostrar el incumplimiento del informe',
	'dashboards.cytology.solve': 'Resolver',
	'dashboards.cytology.nonComplianceDisplayed':
		'Incumplimientos mostrados en el texto final del informe',
	'dashboards.cytology.listItems': 'Lista de elementos de la columna ',
	'dashboards.cytology.toMove': 'para mover',
	'dashboards.cytology.origin': 'Origen::',
	'dashboards.cytology.destiny': ' Destino:',
	'dashboards.cytology.errorBlades':
		'Error al mover las cuchillas seleccionadas',
	'dashboards.cytology.successBlades': 'Cuchillas movidas con éxito',
	'dashboards.cytology.selectNonConformity':
		'Es necesario seleccionar una no conformidad',
	'dashboards.cytology.bladesCreated': 'Hoja creada con éxito',

	/* 07.Inmunología */

	'dashboards.immunology.blockedImpedingNonconformity':
		'¡Bloqueado por impedir la no conformidad!',
	'dashboards.immunology.unexpectedErrorOccurred':
		'Ocurrió un error inesperado',
	'dashboards.immunology.immunologySlides': 'Inmunología láminas',

	/* 08.Control de tareas */

	'dashboards.taskControl.general': 'Control de tareas',
	'dashboards.taskControl.type': 'Elige un tipo',
	'dashboards.taskControl.initialFilter': 'Inicial',
	'dashboards.taskControl.finalFilter': 'Final',
	'dashboards.taskControl.blocks': 'Bloques',
	'dashboards.taskControl.immune': 'Inmune',
	'dashboards.taskControl.citologySlides': 'Láminas Citología',
	'dashboards.taskControl.histologySlides': 'Láminas Histología',
	'dashboards.taskControl.titleReportCitologySlides': 'LÁMINAS CITOLOGÍA',
	'dashboards.taskControl.titleReportHistologySlides': 'LÁMINAS HISTOLOGÍA',
	'dashboards.taskControl.exam': 'Examen',
	'dashboards.taskControl.block': 'Bloque',
	'dashboards.taskControl.fragments': 'N° de fragmentos',
	'dashboards.taskControl.macroscopist': 'Macroscopista',
	'dashboards.taskControl.typeCassette': 'Tipo de casete',
	'dashboards.taskControl.material': 'Material',
	'dashboards.taskControl.coloring': 'Colorante',
	'dashboards.taskControl.urgency': 'Urgencia',
	'dashboards.taskControl.nc': 'NC',
	'dashboards.taskControl.printOut': 'Imprimir',
	'dashboards.taskControl.dataSucessfully': 'Éxito',
	'dashboards.taskControl.itemUrgenciaYes': 'Sí',
	'dashboards.taskControl.itemUrgenciaNo': 'No',
	'dashboards.taskControl.itemNCYes': 'Sí',
	'dashboards.taskControl.itemNCNo': 'No',
	'dashboards.taskControl.blade': 'Cuchilla',
	'dashboards.taskControl.linkedExam': 'Examen Vinculado',
	'dashboards.taskControl.bladeType': 'Tipo de cuchilla',
	'dashboards.taskControl.pathologistDoctor': 'Patólogo',
	'dashboards.taskControl.medicalRecord': 'Historial médico',
	'dashboards.taskControl.dateCompleted': 'Fecha de finalización',
	'dashboards.taskControl.antibody': 'Anticuerpo',
	'dashboards.taskControl.clone': 'Clon',
	'dashboards.taskControl.species': 'Especies',
	'dashboards.taskControl.status': 'Status',
	'dashboards.taskControl.noResult': 'Ningún resultado encontrado',
	'dashboards.taskControl.receptacleControl': 'CONTROL DE RECEPTÁCULO',
	'dashboards.taskControl.responsibleMacro': 'Macro responsable',
	'dashboards.taskControl.technicalManager': 'Responsable técnico',
	'dashboards.taskControl.patient': 'Paciente',
	'dashboards.taskControl.canceled': 'Cancelado',

	/* 09.Tareas del Doctor */
	'dashboards.doctorTasks.selectSearchType': 'Seleccionar tipo de búsqueda',
	'dashboards.doctorTasks.selectResponsibleReviewer': 'Seleccionar revisor responsable',
	'dashboards.doctorTasks.examsToReview': 'Exámenes para repasar',
	'dashboards.doctorTasks.revisedExams': 'Exámenes revisados',
	'dashboards.doctorTasks.reportDetails': 'Detalles del informe',
	'dashboards.doctorTasks.releaseBatchReports': 'Publicar informes por lotes',
	'dashboards.doctorTasks.releaseBatch': 'Liberación por lotes',
	'dashboards.doctorTasks.orderNumber': 'Pedido no.',
	'dashboards.doctorTasks.examNumber': 'Examen no.',
	'dashboards.doctorTasks.insert': 'Insertar',
	'dashboards.doctorTasks.orderAlreadyEntered': 'El pedido ya ha sido ingresado',
	'dashboards.doctorTasks.ordersReleasedSuccessfully': 'Pedidos liberados con éxito',
	'dashboards.doctorTasks.partiallyReleasedOrders': 'Algunas órdenes no fueron publicadas. Estos permanecerán en la parrilla',
	'dashboards.doctorTasks.unreleasedOrders': 'Había un problema. Los pedidos no han sido liberados',
	'dashboards.doctorTasks.enterYourSSN': 'Introduzca su DNI',
	'dashboards.doctorTasks.enterYourSSN': 'Introduzca su PIN',

	/* 10. Descartar material */

	'dashboards.disposalMaterials.initialFilter': 'Inicial',
	'dashboards.disposalMaterials.finalFilter': 'Final',
	'dashboards.disposalMaterials.type.special': 'Especial',
	'dashboards.disposalMaterials.type.burial': 'Entierro',
	'dashboards.disposalMaterials.type.standard': 'Patrón',
	'dashboards.disposalMaterials.discardReports':
		'INFORME SOBRE MATERIALES DE ELIMINACIÓN',
	'dashboards.disposalMaterials.discardedReports':
		'REPORTE DE MATERIALES DESECHADOS',
	'dashboards.disposalMaterials.signatureCRM': 'Suscripción - CRM',
	'dashboards.disposalMaterials.general': 'Eliminación de Materiales',
	'dashboards.disposalMaterials.discardedMaterials': 'Materiales desechados',
	'dashboards.disposalMaterials.reports': 'Informes',
	'dashboards.disposalMaterials.chooseOne': 'Escoge uno',
	'dashboards.disposalMaterials.disposalDate': 'Fecha de disposición',
	'dashboards.disposalMaterials.lotDescription': 'Descripción del lote',
	'dashboards.disposalMaterials.items': 'Elementos',
	'dashboards.disposalMaterials.examNumber': 'Número de examen',
	'dashboards.disposalMaterials.totalWeight': 'Peso Total',
	'dashboards.disposalMaterials.user': 'Usuario',
	'dashboards.disposalMaterials.reportType': 'Tipo de informe',
	'dashboards.disposalMaterials.standardDiscard': 'Descarte estándar',
	'dashboards.disposalMaterials.specialDisposal': 'Descarte especial',
	'dashboards.disposalMaterials.burialDisposal': 'Descarte de entierro',
	'dashboards.disposalMaterials.burialReport': 'Informe de entierro',
	'dashboards.disposalMaterials.requestDate': 'Fecha de solicitud',
	'dashboards.disposalMaterials.discardDate': 'Fecha de disposición',
	'dashboards.disposalMaterials.dueDate': 'Fecha de caducidad',
	'dashboards.disposalMaterials.dateSolicitation': 'Fecha de solicitación',
	'dashboards.disposalMaterials.materialDescription':
		'Descripción del material',
	'dashboards.disposalMaterials.daysExpire': 'Días para expirar',
	'dashboards.disposalMaterials.bottleIdentification':
		'Identificación de botellas',
	'dashboards.disposalMaterials.examNumber': 'Número de examen',
	'dashboards.disposalMaterials.requestNumber': 'Numéro del pedido',
	'dashboards.disposalMaterials.patient': 'Paciente',
	'dashboards.disposalMaterials.toDiscard': 'Descartar',
	'dashboards.disposalMaterials.discardAll': 'Descartar todo',
	'dashboards.disposalMaterials.description': 'Descripción',
	'dashboards.disposalMaterials.restore': 'Restaurar',
	'dashboards.disposalMaterials.restoreAll': 'Restaura todo',
	'dashboards.disposalMaterials.printOut': 'Imprimir',
	'dashboards.disposalMaterials.filters': 'Filtros',
	'dashboards.disposalMaterials.burial': 'Entierro',
	'dashboards.disposalMaterials.noResult': 'Ningún resultado encontrado',
	'dashboards.disposalMaterials.dataSucessfully': 'Éxito',
	'dashboards.disposalMaterials.table.exam': 'Examen',
	'dashboards.disposalMaterials.table.request': 'Solicitud',
	'dashboards.disposalMaterials.table.dayExpire': 'Días para expirar',
	'dashboards.disposalMaterials.table.patient': 'Paciente (Registro Civil)',
	'dashboards.disposalMaterials.table.socialName': 'Nombre Social',
	'dashboards.disposalMaterials.table.weight': 'Peso (g)',
	'dashboards.disposalMaterials.table.material': 'Material',
	'dashboards.disposalMaterials.table.bottle': 'Botella',
	'dashboards.disposalMaterials.table.nobottle':
		'¡Este informe no tiene ninguna botella!',
	'dashboards.disposalMaterials.table.requestDate': 'Fecha de solicitud',
	'dashboards.disposalMaterials.table.expirationDate': 'Fecha de caducidad',
	'dashboards.disposalMaterials.table.deliveryDate': 'Fecha de entrega',
	'dashboards.disposalMaterials.table.totalDiscard': 'Descarte total:',
	'dashboards.disposalMaterials.table.materialsTotalDiscard':
		'Total de materiales desechados',
	'dashboards.disposalMaterials.table.items': 'Elementos',
	'dashboards.disposalMaterials.table.exams': 'Examenes',
	'dashboards.disposalMaterials.table.user': 'Usuario',
	'dashboards.disposalMaterials.table.observationDiscard':
		'Descartar observación',
	'dashboards.disposalMaterials.table.descriptionLot': 'Descripción del lote',
	'dashboards.disposalMaterials.modal.disposalInformation':
		'Información de eliminación',
	'dashboards.disposalMaterials.modal.weightG': 'Peso en (G):',
	'dashboards.disposalMaterials.modal.weightKG': 'Peso en (KG):',
	'dashboards.disposalMaterials.modal.observation': 'Observación:',
	'dashboards.disposalMaterials.modal.reasonDiscard': 'Motivo de descarte',
	'dashboards.disposalMaterials.modal.wantPrint': 'Quiero imprimir',
	'dashboards.disposalMaterials.modal.cancel': 'Cancelar',
	'dashboards.disposalMaterials.modal.confirm': 'Confirmar',

	/* 11.Archivo de materiales */

	'general.materialArchiving.user': 'Usuario',
	'general.materialArchiving.error': 'Error',
	'general.materialArchiving.save': 'Guardar',
	'general.materialArchiving.description': 'Descripción',
	'general.materialArchiving.close': 'Cerrar',
	'general.materialArchiving.toMove': 'Mover',
	'general.materialArchiving.confirm': 'Confirmar',
	'general.materialArchiving.toFile': 'Archivar',
	'general.materialArchiving.initial': 'Inicial',
	'general.materialArchiving.final': 'Final',
	'general.materialArchiving.identification': 'Identificación',
	'general.materialArchiving.noResultsFound': 'Ningún resultado encontrado',
	'general.materialArchiving.material': 'Material',
	'general.materialArchiving.type': 'Tipo',
	'general.materialArchiving.selectType': 'Seleccione tipo',
	'general.materialArchiving.selectDestination': 'Seleccionar destino',
	'general.materialArchiving.selectTheApplicant': 'Seleccione el solicitante',
	'general.materialArchiving.patient': 'Paciente',
	'general.materialArchiving.socialName': 'Nombre Social',
	'general.materialArchiving.technician': 'Técnico',
	'general.materialArchiving.requestDate': 'Fecha de solicitud',
	'general.materialArchiving.expectedReturnDate': 'Fecha de regreso prevista',
	'general.materialArchiving.expectedDate': 'Fecha prevista',
	'general.materialArchiving.filingDate': 'Fecha de archivo',
	'general.materialArchiving.completionDate': 'Fecha de Terminación',
	'general.materialArchiving.dateOfChange': 'Fecha de cambio',
	'general.materialArchiving.completed': 'Terminado',
	'general.materialArchiving.cancel': 'Cancelar',
	'general.materialArchiving.details': 'Detalles',
	'general.materialArchiving.request': 'Solicitud',
	'general.materialArchiving.audit': 'Auditoría',
	'general.materialArchiving.requested': 'Solicitados',
	'general.materialArchiving.addRequisition': 'Agregar Solicitud',
	'general.materialArchiving.archived': 'Archivado',
	'general.materialArchiving.archiveds': 'Archivados',
	'general.materialArchiving.requester': 'Solicitante',
	'general.materialArchiving.theBlock': 'el bloque',
	'general.materialArchiving.block': 'Bloque',
	'general.materialArchiving.blocks': 'Bloques',
	'general.materialArchiving.blocksAndBlades': 'Bloques y Láminas',
	'general.materialArchiving.blockMoved': 'Bloque Movido',
	'general.materialArchiving.movedBlade': 'Lámina Movida',
	'general.materialArchiving.successfully': 'con éxito',
	'general.materialArchiving.success': 'Éxito',
	'general.materialArchiving.theBlade': 'a lámina',
	'general.materialArchiving.blade': 'Lámina',
	'general.materialArchiving.blades': 'Láminas',
	'general.materialArchiving.anErrorOccurred': 'Ocurrió un error al mover',
	'general.materialArchiving.successfullyRemoved':
		'Eliminado con éxito del archivo',
	'general.materialArchiving.materialType': 'Tipo de Material',
	'general.materialArchiving.examNumber': 'Número de Examen',
	'general.materialArchiving.exam': 'Examen',
	'general.materialArchiving.confirmationManualArchiving':
		'Confirmación para archivado manual',
	'general.materialArchiving.reason': 'Razón',
	'general.materialArchiving.informTheReason': 'Informar el motivo',
	'general.materialArchiving.location': 'Ubicación física del bloque y/o lámina',
	'general.materialArchiving.materialLocation': 'Ubicación de materiales',
	'general.materialArchiving.previousLocations': 'Ubicaciones anteriores',
	'general.materialArchiving.registerNewLocation': 'Registrar nueva ubicación',
	'general.materialArchiving.manualArchiving': 'Archivo manual',
	'general.materialArchiving.archiving': 'Archivo',
	'general.materialArchiving.archivingDoneSuccessfully':
		'Archivado realizado con éxito',
	'general.materialArchiving.medicalRecord': 'Historial médico',
	'general.materialArchiving.destiny': 'Destino',
	'general.materialArchiving.report': 'Reporte',
	'general.materialArchiving.operation': 'Operación',
	'general.materialArchiving.maximumCharacters':
		'Número máximo de caracteres alcanzado',
	'general.materialArchiving.remain': 'Quedan',
	'general.materialArchiving.characters': 'caracteres',
	'general.materialArchiving.informTheLocationStored':
		'Informar el lugar donde se almacenará el material.',
	'general.materialArchiving.removeArchive':
		'¿Está seguro de que desea eliminar del archivo el ',
	'general.materialArchiving.remove': 'Eliminar',
	'general.materialArchiving.reportType': 'Tipo de informe',
	'general.materialArchiving.chooseOne': 'Escoge uno',
	'general.materialArchiving.exportCSV': 'Exportar CSV',
	'general.materialArchiving.printOut': 'Imprimir',
	'general.materialArchiving.uninformed': 'No informado',
	'general.materialArchiving.AUDITREPORTOFFILINGANDMATERIALREQUEST':
		'INFORME DE AUDITORÍA DE PRESENTACIÓN Y SOLICITUD DE MATERIAL',
	'general.materialArchiving.deliveredToThePatient': 'Entregado al paciente',
	'general.materialArchiving.requestCancellationCompleted!':
		'Solicitud de cancelación completada con éxito!',
	'general.materialArchiving.shouldBeForwardedToHistologySlides':
		'Debe enviarse a histology láminas',
	'general.materialArchiving.shouldBeForwardedImmunologySlides':
		'Debe enviarse a inmunología láminas',
	'general.materialArchiving.materialRequisitionCancellation':
		'Cancelación de solicitud de material',
	'general.materialArchiving.noBlocksOrSlidesAvailable':
		'Este examen no tiene bloques ni diapositivas disponibles',
	'general.materialArchiving.requestMadeSuccessfully':
		'Solicitud realizada con éxito',
	'general.materialArchiving.confirmationForMaterialRequisition':
		'Confirmación de solicitud de material.',
	'general.materialArchiving.materialRequisitionRequestInformation':
		'Información de solicitud de requisición de material',
	'general.materialArchiving.ArchivingReason': 'Ubicación',

	/* 12.Informes */

	'dashboards.reports.criticalReport': 'Informe crítico',
	'dashboards.reports.disposalMaterials': 'Eliminación de Materiales',
	'dashboards.reports.archiving': 'Archivando',
	'dashboards.reports.taskControl': 'Control de tareas',
	'dashboards.reports.requestsPanel': 'Panel de solicitudes',
	'dashboards.reports.reportsCID': 'Informes S/ CID',
	'dashboards.reports.invoicing': 'Facturación',
	'dashboards.reports.all': 'Todos',
	'dashboards.reports.doctorResponsible': 'Médico responsable',
	'dashboards.reports.searchType': 'Tipo de búsqueda',
	'dashboards.reports.selectOption': 'Seleccione una opción',
	'dashboards.reports.initial': 'Inicial',
	'dashboards.reports.last': 'Final',
	'dashboards.reports.printOut': 'Imprime',
	'dashboards.reports.deliveryDate': 'Fecha de entrega',
	'dashboards.reports.requestDate': 'Fecha de solicitud',
	'dashboards.reports.examNumber': 'Número de examen',
	'dashboards.reports.noResults': 'No hay resultados.',
	'dashboards.reports.requestNumber': 'Numéro del pedido',
	'dashboards.reports.patientName': 'Nombre del paciente',
	'dashboards.reports.observationReport': 'Observación del informe',
	'dashboards.reports.examType': 'Tipo de examen',
	'dashboards.reports.urgent': 'Urgente',
	'dashboards.reports.totalCriticalExams': 'Exámenes críticos totales:',
	'dashboards.reports.totalReports': 'Informes totales:',
	'dashboards.reports.noResultsFound': 'Ningún resultado encontrado',
	'dashboards.reports.exam': 'Examen',
	'dashboards.reports.status': 'Status',
	'dashboards.reports.patientCivilRegistry': 'Paciente (Registro Civil)',
	'dashboards.reports.socialName': 'Nombre social',
	'dashboards.reports.doctor': 'Médico',
	'dashboards.reports.type': 'Tipo',
	'dashboards.reports.dateRequest': 'Fecha de solicitud',
	'dashboards.reports.medicalRecord': 'Historial Médico',
	'dashboards.reports.notifications': 'Notificaciones',
	'dashboards.reports.yes': 'Sí',
	'dashboards.reports.no': 'No',
	'dashboards.reports.bottle': 'Botella',
	'dashboards.reports.material': 'Material',
	'dashboards.reports.deliverydates': 'Fecha de entrega',
	'dashboards.reports.discardRequestingPhysician':
		'Descartar médico solicitante',
	'dashboards.reports.discardDate': 'Fecha de descarte',
	'dashboards.reports.materialSpecial':
		'INFORME DE MATERIALES DE ELIMINACIÓN ESPECIAL',
	'dashboards.reports.specialRecord': 'REGISTRO DE ELIMINACIÓN ESPECIAL',
	'dashboards.reports.subscriptionCRM': 'Suscripción - CRM',
	'dashboards.reports.burialRequestingPhysician':
		'Médico que solicita el entierro',
	'dashboards.reports.reportBurial':
		'INFORME SOBRE MATERIALES PARA DISPOSICIÓN DE PIEZAS PARA ENTIERRO',
	'dashboards.reports.registrationBurial': 'REGISTRO DE MATERIALES FUNERARIOS',
	'dashboards.reports.doctorMacro': 'Médico resp. Macro',
	'dashboards.reports.materialArchiving': 'Archivo de materiales',
	'dashboards.reports.materialRequest': 'Solicitud de material',
	'dashboards.reports.dateArchiving': 'Fecha de presentación',
	'dashboards.reports.observation': 'Observación',
	'dashboards.reports.reportArchiving': 'INFORME DE ARCHIVO DE MATERIALES',
	'dashboards.reports.requester': 'Solicitante',
	'dashboards.reports.reportMaterialRequest':
		'INFORME DE SOLICITUD DE MATERIAL',
	'dashboards.reports.returnDate': 'Fecha prevista de regreso',
	'dashboards.reports.lastDate': 'Fecha final',
	'dashboards.reports.examCID': 'Total de exámenes sin CID:',
	'dashboards.reports.performingPhysician': 'Médico Ejecutor',
	'dashboards.reports.totalExam': 'Exámenes totales:',
	'dashboards.reports.released': 'Liberado',
	'dashboards.reports.partiallyReleased': 'Liberado parcialmente',
	'dashboards.reports.inProgress': 'En proceso',
	'dashboards.reports.ready': 'Dispuesto',
	'dashboards.reports.pending': 'En espera',
	'dashboards.reports.finished': 'Terminado',
	'dashboards.reports.criticalReportContact':
		'Registro de contacto de informe crítico',
	'dashboards.reports.notifiedRequestingPhysician':
		'Médico solicitante notificado:',
	'dashboards.reports.enterDoctor': 'Entra el medico',
	'dashboards.reports.phone': 'Teléfono',
	'dashboards.reports.comment': 'Comentario:',
	'dashboards.reports.notificationSuccess': 'Notificación creada con éxito',
	'dashboards.reports.criticalReportNotifications':
		'NOTIFICACIONES DE INFORMES CRÍTICOS',
	'dashboards.reports.externalExamNumber': 'Número de examen externo',
	'dashboards.reports.materialDeliveryDate': 'Fecha de entrega de materiales',
	'dashboards.reports.expectedDeliveryDate': 'Fecha de entrega estimada',
	'dashboards.reports.notification': 'Notificación',
	'dashboards.reports.materialDelivered': 'Material entregado',
	'dashboards.reports.estimatedDelivery': 'Tiempo de entrega estimado',
	'dashboards.reports.delivery': 'Entrega',
	'dashboards.reports.criticalReports': 'INFORMES CRÍTICOS',
	'dashboards.reports.examNoNotification': 'Este examen no tiene notificación',
	'dashboards.reports.examNoCassete': 'Este examen no tiene casete',
	'dashboards.reports.noItemsFound': 'No se encontraron artículos',
	'dashboards.reports.examNotFound': 'O exame não foi encontrado',
	'dashboards.reports.informIndication': '¿Quieres informar la indicación?',
	'dashboards.reports.indication': 'Recomendación:',
	'dashboards.reports.burialReport': 'INFORME PARA ENTIERRO',
	'dashboards.reports.typeCassete': 'Tipo de casete',
	'dashboards.reports.fragments': 'Fragmentos',
	'dashboards.reports.medicalRecordRGHC': 'Historial médico / RGHC',
	'dashboards.reports.yearsOld': 'La edad',
	'dashboards.reports.antibodies': 'Anticuerpos',
	'dashboards.reports.inconclusive': 'Poco concluyente',
	'dashboards.reports.negative': 'Negativo',
	'dashboards.reports.positive': 'Positivo',
	'dashboards.reports.antigenRequisitionReport':
		'INFORME DE SOLICITUD DE ANTÍGENO',
	'dashboards.reports.printPreview': 'Vista previa de impresión',

	/* 13.Panel de Solicitudes */

	'general.requestsPanel.title': 'Panel de solicitudes',
	'general.requestsPanel.status': 'Estado',
	'general.requestsPanel.requestChangedSuccessfully':
		'Solicitud cambiada con éxito',
	'general.requestsPanel.all': 'Todos',
	'general.requestsPanel.error': 'Error',
	'general.requestsPanel.type': 'Tipo',
	'general.requestsPanel.initial': 'Inicial',
	'general.requestsPanel.final': 'Final',
	'general.requestsPanel.selectType': 'Seleccione tipo',
	'general.requestsPanel.selectStatus': 'Seleccionar estado',
	'general.requestsPanel.selectAll': 'Seleccionar todo',
	'general.requestsPanel.close': 'Cerrar',
	'general.requestsPanel.save': 'Guardar',
	'general.requestsPanel.date': 'Fecha',
	'general.requestsPanel.success': 'Éxito',
	'general.requestsPanel.request': 'Solicitud',
	'general.requestsPanel.requestDate': 'Fecha de solicitud',
	'general.requestsPanel.registrationDate': 'Fecha de Registro',
	'general.requestsPanel.dateOfChange': 'Fecha de cambio',
	'general.requestsPanel.requestDetails': 'Solicitud detalles',
	'general.requestsPanel.requestingUser': 'Usuario solicitante',
	'general.requestsPanel.executingUser': 'Usuario Ejecutante',
	'general.requestsPanel.comment': 'Comentario',
	'general.requestsPanel.registrationOfRequests': 'Registro de solicitudes',
	'general.requestsPanel.requester': 'Solicitante',
	'general.requestsPanel.requested': 'Solicitado',
	'general.requestsPanel.performer': 'Ejecutante',
	'general.requestsPanel.identifier': 'Identificador',
	'general.requestsPanel.searchType': 'Tipo de Búsqueda',
	'general.requestsPanel.selectAnOption': 'Seleccione una opción',
	'general.requestsPanel.doctorResponsible': 'Médico responsable',
	'general.requestsPanel.initial': 'Inicial',
	'general.requestsPanel.final': 'Final',
	'general.requestsPanel.patient': 'Paciente',
	'general.requestsPanel.medicalRecord': 'Historial médico',
	'general.requestsPanel.print': 'Imprimir',
	'general.requestsPanel.bottle': 'Botella',
	'general.requestsPanel.block': 'Bloque',
	'general.requestsPanel.selectBlock': 'Selecciona Bloque',
	'general.requestsPanel.exam': 'Examen',
	'general.requestsPanel.totalExams': 'Exámenes totales',
	'general.requestsPanel.examNumber': 'Número de Examen',
	'general.requestsPanel.totalRequests': 'Solicitudes totales',
	'general.requestsPanel.noResultsFound': 'Ningún resultado encontrado',
	'general.requestsPanel.colorations': 'Coloraciones',
	'general.requestsPanel.selectColors': 'Seleccione los colores',
	'general.requestsPanel.errorListingItems': 'Error al enumerar elementos',
	'general.requestsPanel.necessaryInformType': 'Es necesario informar el tipo',
	'general.requestsPanel.necessaryInformBottle':
		'Es necesario informar a la botella',
	'general.requestsPanel.necessaryInformBlock':
		'Es necesario informar al bloque',
	'general.requestsPanel.requestCreatedSuccessfully':
		'Solicitud creada con éxito',
	'general.requestsPanel.requestsMade': 'SOLICITUDES REALIZADAS',
	'general.requestsPanel.signature': 'Firma',
	'general.requestsPanel.newCut': 'Nuevo corte',
	'general.requestsPanel.deepening': 'Profundizando',
	'general.requestsPanel.inProgress': 'En proceso',
	'general.requestsPanel.done': 'Hecho',

	/* 14. Seguimiento de muestras - NUEVO */

	'dashboards.sample.fillAllFormFields':
		'Rellene todos los campos del formulario',
	'dashboards.sample.userOf': 'Usuario de',
	'dashboards.sample.userFor': 'Usuario a',
	'dashboards.sample.process': 'Procesos',
	'dashboards.sample.processOf': 'Proceso de',
	'dashboards.sample.processFor': 'Proceso a',
	'dashboards.sample.searchByExamNumber': 'Buscar por número de examen',
	'dashboards.sample.clearSelected': 'Borrar seleccionado',
	'dashboards.sample.users': 'Usuarios',
	'dashboards.sample.fillTheCollection':
		'Rellena todos los datos para la recogida',
	'dashboards.sample.thisItemHasAdded': 'Este artículo ya ha sido agregado',
	'dashboards.sample.bladesCreatedSuccessfully':
		'¡Cuchillas creadas con éxito!',
	'dashboards.sample.itemsMovedSuccessfully': 'Elementos movidos con éxito',
	'dashboards.sample.changeTheType': '¿Realmente quieres cambiar el tipo?',
	'dashboards.sample.tableDataErased': 'Los datos de la tabla se borrarán',
	'dashboards.sample.technicianName': 'Nombre del técnico',

	/* 15.Página de error */

	'error.title': 'Hubo un error en la página',
	'error.code': 'El código de error encontrado fue',
	'error.gobackhome': 'Volver a Inicio',
	'error.notfoundpage': 'Página no encontrada',
	'error.notfoundpagedesc': 'No se pudo encontrar la página solicitada',

	/* 16.Mensajes */

	'message.noExamFound': 'No se encontró ningún examen',
	'message.examFound': 'Examen(es) encontrado(s)',
	'message.loading': 'Cargando...',
	'message.maxlength': 'Número máximo de caracteres alcanzado',
	'message.remaining.more': 'Quedan {char} caracteres',
	'message.remaining.only': 'Queda {char} caracter',
	'message.errorEditor':
		'Error al cargar el editor. Recargar la página para volver a intentarlo',
	'message.welcome': 'Bienvenido(a)',
	'message.expired': 'Sesión expirada',
	'message.userNotCheck': 'El usuario no verifica',
	'message.notPermission': 'Permiso no encontrado',
	'message.permissionNot': 'El permiso no verifica',
	'messages.noChargeReport': '¡No se puede cargar el informe!',
	'message.expired.renewSession' : 'Cerrarás tu sesión en <b></b> segundos' + '<div class="mt-4"></div>' + '<button id="increase" class="btn btn-primary">' + 'Continuar sesión' + '</button><br/><br/>',

	/* 17.Period */
	'period.name': 'Período',
	'period.order.request': 'Período de pedido',
	'period.delegation': 'Período de delegación',
	'period.all': 'Todos',
	'period.today': 'Hoy',
	'period.yesterday': 'Ayer',
	'period.daybeforeyesterday': 'Antes de ayer',
	'period.has1week': 'hace 1 semana',
	'period.has15days': 'Son 15 días',
	'period.has1month': 'Hace 1 mes',
	'period.has2months': 'Hace 2 meses',
	'period.has3months': 'Hace 3 meses',
	'period.has6months': 'Hace 6 meses',
	'period.has1year': 'Hace 1 año',
	'period.other': 'Otro',
	'period.datestart': 'Fecha de inicio',
	'period.dateend': 'Fecha de finalización',

	/* 18.Lista de verificación */
	'checklist.resp': 'Respuesta',
	'checklist.modalTitle': 'Lista de verificación de recibo de muestra',

	/* .Encaminhamento */

	'dashboards.referral.referral': 'Derivación a segunda opinión',
	'dashboards.referral.doctorAssigned': 'Médico asignado a 2ª opinión',

	/* Entrega de resultados */
	'dashboard.resultsScreen.modal.deliveryofexams': 'Entrega de examenes',
	'dashboard.resultsScreen.modal.carryoutdelivery': 'Hacer entrega',
	'dashboard.resultsScreen.modal.history': 'Histórico',
	'dashboard.resultsScreen.modal.deliveredto': 'Entregado a:',
	'dashboard.resultsScreen.modal.cpf': ' DNI:',
	'dashboard.resultsScreen.modal.notes': 'Notas',
	'dashboard.resultsScreen.modal.internalnotes': 'Notas Internas',
	'dashboard.resultsScreen.modal.noteswillnotbeincludedinthedeliveryprotocol':
		' *No se incluirán notas en el protocolo de entrega',
	'dashboard.resultsScreen.modal.externaldocumentreturnedpatient':
		'Documento(s) externo(s) para devolver al paciente:',
	'dashboard.resultsScreen.modal.examresult': 'Resultado del examen',
	'dashboard.resultsScreen.modal.deliveryprotocol': 'Protocolo de entrega',
	'dashboard.resultsScreen.modal.delivermaterial': 'Entregar material',
	'dashboard.resultsScreen.modal.deliverycanceled': 'Entrega cancelada',
	'dashboard.resultsScreen.modal.deliveredby': 'Entregado por',
	'dashboard.resultsScreen.modal.canceled': 'Cancelar',
	'dashboard.resultsScreen.modal.deliver': 'Entregar',
	'dashboard.resultsScreen.modal.confirm': 'Confirmar',
	'dashboard.resultsScreen.modal.sheets': 'Cuchillas:',
	'dashboard.resultsScreen.modal.block': 'Bloques:',
	'dashboard.resultsScreen.modal.selectdelivereditems':
		'Seleccionar artículos entregados',
	'dashboard.resultsScreen.modal.deliveredin': '; entregado en',
	'dashboard.resultsScreen.modal.description': 'Descripción: ',
	'dashboard.resultsScreen.modal.type': 'Tipo: ',
	'dashboard.resultsScreen.modal.reportViewedBy': 'Informe visto/impreso por ',
	'dashboard.resultsScreen.modal.originPortal': 'a través del portal de exámenes',

	/* Modal óbito */
	'data.obito':'Datos de defunción',
	'modalobito.title':'Información de defunción',
	'dateandhour.obito':'Fecha y hora de la muerte:',
	'observations.obito':'Observaciones:',
	'messages.obito.updateSucess': '¡Información actualizada exitosamente!',
	'messages.obito.updateError': '¡Hubo un error al actualizar la información!',
	'messages.obito.insertSucess': '¡Información insertada exitosamente!',
	'messages.obito.insertError': '¡Hubo un error al insertar información!',
	'messages.obito.removeSucess': '¡Información eliminada exitosamente!',
	'messages.obito.removeError': '¡Hubo un error al eliminar información!',

	/* Agrupar exames */
	'dashboard.groupExams.modal.title': 'Solicitar exámenes en grupo al recibir el material',
	'dashboard.groupExams.modal.title': 'Exámenes grupales',
};



// WEBPACK FOOTER //
// ./src/lang/locales/es_ES.js